var exports = {
  "CR": "CustomStatusModal.module__modalRoot___VUZZSX",
  "_l": "CustomStatusModal.module__previewSection___VUZZSX",
  "uG": "CustomStatusModal.module__statusInputWrapper___VUZZSX",
  "Dq": "CustomStatusModal.module__characterCount___VUZZSX",
  "DY": "CustomStatusModal.module__emojiTriggerButton___VUZZSX",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___VUZZSX",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___VUZZSX",
  "J7": "CustomStatusModal.module__clearButtonIcon___VUZZSX",
  "qr": "CustomStatusModal.module__footer___VUZZSX",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___VUZZSX",
  "uD": "CustomStatusModal.module__expirationLabel___VUZZSX",
  "S2": "CustomStatusModal.module__expirationSelect___VUZZSX",
};

module.exports = exports;
